export default {
    'msg001':                   'Magandang araw',
    'msg002':                   'Mabuhay',
    'msg003':                   'Ka-may-ari',
    'msg004':                   'Gusto naming mapabuti pa ang aming serbisyo. Bigyan ng rating ang aming serbisyo, Ka-may-ari!',
    'msg005':                   'Laktawan',
    'msg006':                   'Sa susunod na lang',
    'msg007':                   'Natapos na ang iyong session',
    'msg008':                   'Oops! May nangyaring error. Ikaw ay na-log out mula sa iyong current session.',
    'msg009':                   'Hindi nakatanggap ng code?',
    'msg010':                   'Branch Log Out',
    'msg011':                   'Sigurado ka bang ila-log out mo itong PSO mula sa PAFCPIC Information Kiosk system? Kung hindi mo ito sinasadyang gawin o kailangan mo ng tulong, kontakin ang PAFCPIC IT Division.',
    'msg012':                   'No activity detected. Ikaw ay ila-log out sa loob ng',
    'msg013':                   'segundo',
    'msg014':                   'maliban kung kumpirmahin mong ginagamit mo pa ang kiosk.',
    'msg015':                   'Sigurado ka bang nais mong mag-log out?',
    'msg016':                   'Ginagamit mo pa ang kiosk, Ka-may-ari?',
    'msg017':                   'Yay! Ano ang mga nagustuhan mo?',
    'msg018':                   'Ano ang pwede naming ayusin?',
    'btn001':                   'Ok',
    'btn002':                   'Magpatuloy',
    'btn003':                   'Bumalik',
    'btn004':                   'Mag-log out',
    'btn005':                   'Balance',
    'btn006':                   'All',
    'btn007':                   'Summary',
    'btn008':                   'I-submit',
    'btn009':                   'I-verify',
    'btn010':                   'I-cancel',
    'btn011':                   'Manatiling naka-log in',
    'btn012':                   'Hindi',
    'btn013':                   'Oo',
    'btn014':                   'Magpatuloy',
    'btn015':                   'Hindi ako iyan',
    'stp001':                   'Pindutin para magsimula',
    'lop001':                   'Pumili kung paano mo gustong mag-log in',
    'lop002':                   'PAPSI Mobile Account',
    'lop003':                   'Account/Serial No.',
    'lop004':                   'QR Code',
    'pma001':                   'Ilagay ang iyong PAPSI Mobile login credentials',
    'pma002':                   'Ilagay ang iyong PAPSI Mobile Account',
    'pma003':                   'Ilagay ang iyong username',
    'pma004':                   'Ilagay ang iyong password',
    'asn001':                   'Punan ang mga sumusunod na detalye sa pag-login',
    'asn002':                   'Ilagay ang iyong Account/Serial Number',
    'asn003':                   'Ilagay ang',
    'asn004':                   'Ilagay ang iyong Account Number',
    'asn005':                   'Ilagay ang iyong Serial Number',
    'qrc001':                   'Siguraduhing ang QR code ay nasa loob ng frame',
    'qrc002':                   'I-scan ang QR Code',
    'enp001':                   'Ilagay ang iyong PIN mula sa iyong PAPSI Mobile App',
    'enp002':                   'Ilagay ang iyong Personal Identification Number (PIN)',
    'enp003':                   'I-enroll ang iyong PIN bago magpatuloy sa paggamit ng kiosk',
    'enp004':                   'Kumpirmahin ang mga detalye ng iyong account',
    'enp005':                   'Kumpirmahin kung sa iyo account na ito, Ka-may-ari',
    'enp006':                   'Ilagay ulit ang iyong PIN ',
    'enp007':                   'Palitan ang iyong PIN. Ang unang ibinigay na PIN ay pansamantala lamang at kailangang palitan para sa iyong seguridad',
    'enp008':                   'I-update ang iyong temporary PIN',
    'enp009':                   'Maligayang pagbabalik, Ka-May-Ari!',
    'enp010':                   'Para sa seguridad, kailangan mong i-update ang iyong temporary PIN bago magpatuloy.',
    'smp001':                   'Piliin ang transaksyon na nais mong gawin',
    'smp002':                   'Tingnan ang balanse',
    'smp003':                   'Impormasyon ng Miyembro',
    'smp004':                   'Numero sa iyong pila',
    'smp005':                   'Kailangan ng tulong?',
    'bip001':                   'Piliin ang nais na uri ng balanse',
    'bip002':                   'Share Capital',
    'bip003':                   'Savings',
    'bip004':                   'Loans',
    'led001':                   'Narito ang iyong mga transaksyon',
    'led002':                   'mula',
    'led003':                   'Ipinapakita ang',
    'led004':                   'na resulta',
    'led005':                   'Itago ang may balanse na zero',
    'led006':                   'Ipakita ang may balanse na zero',
    'led008':                   'Petsa',
    'led009':                   'Reference',
    'led010':                   'Debit',
    'led011':                   'Credit',
    'led012':                   'Balanse',
    'led013':                   'sa',
    'led014':                   'Itago ang mga balanse',
    'led015':                   'Ipakita ang mga balanse',
    'led016':                   'Kung may iba ka pang katanungan o kailangan ng tulong, lumapit lang sa aming PSO Personnel',
    'mip001':                   'Tingnan ang iyong impormasyon',
    'mip002':                   'Account No',
    'mip003':                   'Serial No',
    'mip004':                   'Uri ng Membership',
    'mip005':                   'Mobile Number',
    'mip006':                   'Email Address',
    'mip007':                   'Petsa ng Kapanganakan',
    'mip008':                   'TIN',
    'mip009':                   'Ilagay ang iyong bagong number',
    'mip010':                   'Ilagay ang iyong bagong email address',
    'mip011':                   'Idagdag ang Araw ng Kapanganakan',
    'mip012':                   'Idagdag ang iyong TIN',
    'mip013':                   'Impormasyon ng Member',
    'mip014':                   'Walang ibinigay na petsa ng kapanganakan',
    'mip015':                   'Walang ibinigay na TIN',
    'mip016':                   'Success! Updated na ang mga pagbabagong ginawa mo.',
    'mip017':                   'Ilagay ang iyong lumang PIN',
    'mip018':                   'Ilagay ang iyong bagong PIN',
    'mip019':                   'Kumpirmahin ang bagong PIN',
    'mip020':                   'Ilagay ang iyong PIN',
    'mip021':                   'I-confirm ang iyong PIN',
    'mip022':                   'I-enroll ang iyong PIN bago magpatuloy sa paggamit ng kiosk',
    'has001':                   'Ano ang maitutulong namin, Ka-may-ari?',
    'has002':                   'Help and Support',
    'has003':                   'End-User License Agreement',
    'has004':                   'Privacy Policy',
    'has005':                   'Contact Support',
    'has006':                   'Basahin ang End-User License Agreement',
    'has007':                   'Basahin ang Privacy Policy',
    'has008':                   'Ipadala ang iyong mga tanong, komento, o suhestyon',
    'has009':                   'Office Hours',
    'otp001':                   'I-send ulit',
    'otp002':                   'I-send ulit sa loob ng',
    'otp003':                   'segundo',
    'otp004':                   'OTP Verification',
    'otp005':                   'Ilagay ang OTP na natanggap sa iyong email o mobile number para patunayan ang iyong pagkakakilanlan', 
    'load01':                   'Sandali lang, Ka-may-ari'
}
